import { parseConsentClauseIds } from "./deliveryConsent";

const EXPIRY_LEN = 10;

function base64UrlEncode(str) {
    const base64 = btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, hex) =>
            String.fromCharCode(parseInt(hex, 16))
        )
    );
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function base64UrlDecode(token) {
    let base64 = token.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) {
        base64 += "=".repeat(4 - pad);
    }
    const binary = atob(base64);
    return decodeURIComponent(
        Array.from(binary, (c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
    );
}

function decodeLegacyPayload(payload) {
    if (payload.length <= EXPIRY_LEN + 1) {
        return null;
    }

    const t = payload[0];
    if (t !== "f" && t !== "d") {
        return null;
    }

    const e = parseInt(payload.slice(-EXPIRY_LEN), 10);
    const i = payload.slice(1, -EXPIRY_LEN);

    if (!i || Number.isNaN(e) || e <= 0) {
        return null;
    }

    return { t, i, e };
}

export function encodePayload({ t, i, e, rk, n, c, downloadAll }) {
    const data = { t, i, e: Number(e) };
    if (rk) {
        data.rk = rk;
    }
    const name = typeof n === "string" ? n.trim() : "";
    if (name) {
        data.n = name;
    }
    // 知情同意条款：存储为编号 CSV（如 "1,3,4"）或 "none"。
    const consent = typeof c === "string" ? c.trim() : "";
    if (consent) {
        data.c = consent;
    }
    // 自包含链接也支持“下载所有照片”：用短键 da:{t,v} 压缩体积。
    if (downloadAll && downloadAll.type && downloadAll.value) {
        data.da = { t: downloadAll.type, v: downloadAll.value };
    }
    return base64UrlEncode(JSON.stringify(data));
}

function parseDownloadAll(da) {
    if (da && (da.t === "zip" || da.t === "gdrive") && da.v) {
        return { type: da.t, value: String(da.v) };
    }
    return null;
}

export function decodeToken(token) {
    if (!token || typeof token !== "string") {
        return null;
    }

    try {
        const payload = base64UrlDecode(token);

        if (payload.startsWith("{")) {
            const data = JSON.parse(payload);
            if ((data.t !== "f" && data.t !== "d") || !data.i || !data.e) {
                return null;
            }
            const e = Number(data.e);
            if (Number.isNaN(e) || e <= 0) {
                return null;
            }
            return {
                t: data.t,
                i: data.i,
                e,
                rk: data.rk || undefined,
                n: typeof data.n === "string" && data.n.trim() ? data.n.trim() : undefined,
                c: typeof data.c === "string" && data.c.trim() ? data.c.trim() : undefined,
                downloadAll: parseDownloadAll(data.da),
            };
        }

        const legacy = decodeLegacyPayload(payload);
        return legacy ? { ...legacy, downloadAll: null } : null;
    } catch {
        return null;
    }
}

export function isExpired(expiryUtcSeconds) {
    return Date.now() >= expiryUtcSeconds * 1000;
}

export function buildDeliveryUrl(token) {
    const { origin, pathname } = window.location;
    const base = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return `${origin}${base}/#/d/${token}`;
}

export function getAlbumName(payload, fallback) {
    if (payload?.n) {
        return payload.n;
    }
    return fallback || "";
}

export function getConsentClauseIds(payload) {
    return parseConsentClauseIds(payload?.c);
}

export function getConsentKey(token) {
    return `consent:${token}`;
}

export function hasConsent(token) {
    try {
        return sessionStorage.getItem(getConsentKey(token)) === "1";
    } catch {
        return false;
    }
}

export function setConsent(token) {
    try {
        sessionStorage.setItem(getConsentKey(token), "1");
    } catch {
        // sessionStorage unavailable
    }
}
